import { PoweredBy } from 'src/modules/booking/components/powered-by'
import { BookingFormHeader } from './booking-form-header'
import type { BookingQuestionsEditorProps } from './booking-questions-editor.interface'
import classes from './booking-questions-editor.module.scss'
import { LockedFields } from './locked-fields'
import { QuestionCard } from './question-card'
import { QuestionList } from './question-list'
import { QuestionsEmptyState } from './questions-empty-state'

const HEADING_ID = 'booking-form-heading'
const FORM_CAPTION =
  'Name, phone and email are always asked. Answers appear in your new-booking email and on the calendar event.'

export function BookingQuestionsEditor({ editor, copySources, showAddressField }: BookingQuestionsEditorProps) {
  const isAddOpen = editor.openCard?.mode === 'add'

  return (
    <section className={classes.root} aria-labelledby={HEADING_ID}>
      <BookingFormHeader
        headingId={HEADING_ID}
        canAddQuestion={editor.canAddQuestion}
        copyMessage={editor.copyMessage}
        copySources={copySources}
        onAdd={editor.openAddCard}
        onCopy={editor.copyFrom}
      />
      <div className={classes.panel}>
        <div className={classes.eyebrow}>What your customer sees</div>
        <LockedFields showAddressField={showAddressField} />
        <QuestionList editor={editor} />
        {isAddOpen && (
          <QuestionCard mode="add" idPrefix="new-question" onConfirm={editor.addQuestion} onCancel={editor.closeCard} />
        )}
        {!editor.hasOwnerQuestions && !isAddOpen && (
          <QuestionsEmptyState disabled={!editor.canAddQuestion} onAdd={editor.openAddCard} />
        )}
        <PoweredBy className={classes.poweredBy} linked={false} />
      </div>
      <p className={classes.caption}>{FORM_CAPTION}</p>
    </section>
  )
}
